import { NUMBER_SIZE } from '../../../constants/size'
import { FileIconPreview, FileIconType } from '../../FileIcon'
import Text from '../../Text'

import * as styles from './FileImagePreviewError.module.css'

function FileImagePreviewError({
  Overlay,
  className,
  filename,
  fileSize,
  iconType = FileIconType.Image,
  size = NUMBER_SIZE.size44,
  ...overlayProps
}) {
  return (
    <div className={className}>
      <FileIconPreview size={size} type={iconType} />
      {filename ? <Text className={styles.text}>{filename}</Text> : null}
      {fileSize ? (
        <div className={styles.info}>
          <span className={styles.size}>{fileSize}</span>
        </div>
      ) : null}
      {Overlay ? <Overlay {...overlayProps} /> : null}
    </div>
  )
}

export default FileImagePreviewError
